import React, { useEffect } from 'react'
import { View, Image } from 'react-native'
import * as SplashScreen from 'expo-splash-screen'
import { NativeStackScreenProps } from '@react-navigation/native-stack'
import ActivityIndicator from 'APP/Components/ActivityIndicator'
// Styling
import { Images } from 'APP/Themes'
import styled, { useTheme } from 'styled-components/native'
import DialogueBranding from 'APP/Components/DialogueBranding'

type LoadingScreenProps = NativeStackScreenProps<ReactNavigation.RootParamList, 'loading'>

const SplashLogoImage = styled(Image)`
  align-self: center;
  width: 70%;
  height: 160px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin * 2}px;
`

const BrandingContainer = styled(DialogueBranding)`
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
  width: 100%;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.background};
`

const ContentContainer = styled(View)`
  background-color: ${({ theme }) => theme.colors.background};
  align-items: center;
  justify-content: center;
  flex: 1;
`

function LoadingScreen({ route, ...props }: LoadingScreenProps) {
  const theme = useTheme()
  const { hideLogo = false } = { ...route?.params, ...props }

  useEffect(() => {
    SplashScreen.hideAsync()
  }, [])

  return (
    <>
      <ContentContainer testID="LOADING_SCREEN">
        {!hideLogo && (
          <SplashLogoImage
            data-dd-privacy="allow"
            source={Images.logoLockup}
            resizeMode="contain"
          />
        )}
        <ActivityIndicator size="large" color={theme.colors.secondary} />
      </ContentContainer>
      <BrandingContainer />
    </>
  )
}

export default LoadingScreen
